import React from 'react'
import PropTypes from 'prop-types'
import ShareIcon from 'components/shared/icons/share'
// import DownloadIcon from 'components/shared/icons/download'
import FavoriteHeartTextHandler from 'components/shared/favorites/heart-text'
import ShareDropdown from './share-dropdown'

const Actions = ({
  id,
  className = 'lg:flex flex-row w-full mx-auto flex-wrap justify-center text-primary-lightgray text-sm my-2 hidden',
}) => (
  <div className={className}>
    {/* <div className="flex cursor-pointer flex-grow">
      <DownloadIcon />
      <p className="ml-2 text-sm lg:text-sm">Download as PDF</p>
    </div> */}
    <FavoriteHeartTextHandler id={id}>
      <p className="ml-1 text-sm lg:text-sm">Save</p>
    </FavoriteHeartTextHandler>
    <div className="hover-dropdown cursor-pointer ml-8">
      <div className="flex items-center">
        <ShareIcon />
        <p className="ml-1 text-sm lg:text-sm">Share</p>
      </div>
      <ShareDropdown />
    </div>
  </div>
)

Actions.propTypes = {
  id: PropTypes.number,
  className: PropTypes.string,
}

export default Actions
